import App from '@src/App'
import '@styles/App.scss'
import 'overlayscrollbars/overlayscrollbars.css'
import React from 'react'
import { createRoot } from 'react-dom/client'

createRoot(document.getElementById('root')!).render(<App />)
